import {actionTypes} from '../../../types';

// Action creator for generating OTP request
export const sendOtpForMobileVerified = (payload) => ({
    type: actionTypes.SEND_OTP_FOR_MOBILE_VERIFIED_REQUEST,
    payload,
});

// Action creator for successful OTP generation
export const sendOtpForMobileVerifiedSuccess = (payload) => ({
    type: actionTypes.SEND_OTP_FOR_MOBILE_VERIFIED_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const sendOtpForMobileVerifiedFailure = (payload) => ({
    type: actionTypes.SEND_OTP_FOR_MOBILE_VERIFIED_FAILURE,
    payload,
});

// Action creator for resetting OTP generation status
export const sendOtpForMobileVerifiedReset = () => ({
    type: actionTypes.SEND_OTP_FOR_MOBILE_VERIFIED_RESET,
});

// Action creator for resetting all OTP generation reducer
export const sendOtpForMobileVerifiedResetAll = () => ({
    type: actionTypes.SEND_OTP_FOR_MOBILE_VERIFIED_RESET_ALL,
});
